
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TTask, API_TTaskSelect, TTaskSelect } from "@/models/expert_tasks";
import { SMCases } from "@/store";
import { APPROVED_BY_HO_OA_STATUS, REJECTED_BY_HO_OA_STATUS } from "@/constants/services";
import { DOCUMENT_TASK_TYPE, GUIDE_TASK_TYPE } from "@/constants/tasks";
import {
  CANDIDATE_ROLE,
  CANDIDATE_ROLE_LABEL,
  EMPLOYEE_ROLE,
  EMPLOYEE_ROLE_LABEL,
  EMPLOYER_ROLE,
  EMPLOYER_ROLE_LABEL,
} from "@/constants/roles";
import { ASK_POPUP_TYPE } from "@/constants/popupTypes";

const TASK_MODEL = {
  name: "",
  case_progress_step_id: null,
  type: "",
  role: "",
  title: "",
  description: "",
  document_template_v2_id: 0,
};

const TASK_TYPES = [
  { value: DOCUMENT_TASK_TYPE, label: "Document" },
  { value: GUIDE_TASK_TYPE, label: "Guide" },
];

const SERVICES_ROLE_TYPES = [
  { value: EMPLOYER_ROLE, label: EMPLOYER_ROLE_LABEL },
  { value: CANDIDATE_ROLE, label: CANDIDATE_ROLE_LABEL },
];

const COMPLIANCE_COMPANY_ROLE_TYPES = [{ value: EMPLOYER_ROLE, label: EMPLOYER_ROLE_LABEL }];

const COMPLIANCE_ROLE_TYPES = [
  { value: EMPLOYER_ROLE, label: EMPLOYER_ROLE_LABEL },
  { value: EMPLOYEE_ROLE, label: EMPLOYEE_ROLE_LABEL },
];

const COMPANY_LEVEL = "company";

@Component
export default class CreateTaskPopUp extends Vue {
  @Prop({ type: Boolean, default: false }) readonly createTaskPopup!: boolean;
  @Prop({ type: String, default: ASK_POPUP_TYPE }) readonly type!: string;
  @Prop({ type: Boolean, default: false }) readonly isCompliance?: boolean;
  @Prop({ type: String, default: null }) readonly forUserRole?: string;
  @Prop({ type: String, default: null }) readonly level?: string;
  @Prop({ type: Number, default: null }) readonly companyId?: number;
  @Prop({ type: Number, default: null }) readonly userId?: number;
  @Prop({ type: Array, default: () => [] }) readonly progressSteps!: TTaskSelect[];

  showPopup = false;

  // TODO: Refactor it, after refactoring "Nb-dialog" component;
  @Watch("createTaskPopup", { immediate: true })
  createTaskPopupChanged(val: boolean) {
    this.showPopup = val;

    if (!val) return;

    this.init(this.serviceId, this.serviceTemplateId);
  }

  open() {
    this.showPopup = true;
  }

  task: API_TTask = TASK_MODEL;

  get taskRole() {
    return this.task?.role ?? null;
  }

  defaultTask: API_TTask = TASK_MODEL;

  taskTypes: TTaskSelect[] = TASK_TYPES;

  get complianceRoles() {
    return this.level === COMPANY_LEVEL ? COMPLIANCE_COMPANY_ROLE_TYPES : COMPLIANCE_ROLE_TYPES;
  }

  get roleTypes(): TTaskSelect[] {
    return this.isCompliance ? this.complianceRoles : SERVICES_ROLE_TYPES;
  }

  docTemplates: TTaskSelect[] = [];

  // progressSteps: TTaskSelect[] = [];

  showEditor = true;

  get serviceId() {
    return Number(this.$route.params.id ?? 0);
  }

  get isServices() {
    return !this.isCompliance;
  }

  get serviceTemplateId() {
    return SMCases.caseTemplateId;
  }

  get isCaseCompleted() {
    return [REJECTED_BY_HO_OA_STATUS, APPROVED_BY_HO_OA_STATUS].includes(
      SMCases.onlineApplicationStatus
    );
  }

  get isFormValid() {
    const { name, case_progress_step_id, type, role, document_template_v2_id } = this.task;

    if (this.isServices) {
      return (
        name &&
        case_progress_step_id &&
        type &&
        role &&
        (type === DOCUMENT_TASK_TYPE ? document_template_v2_id : true)
      );
    } else {
      return name && type && role && (type === DOCUMENT_TASK_TYPE ? document_template_v2_id : true);
    }
  }

  @Watch("serviceTemplateId")
  updateServiceTemplateId(value: number) {
    this.init(this.serviceId, value);
  }

  init(serviceId: number, templateId: number) {
    if (!serviceId || !templateId) return;

    this.getDocTemplates();
    // this.getCaseProgressSteps(serviceId, templateId);
  }

  @Watch("taskRole")
  taskRoleChanged() {
    this.getDocTemplates();
  }

  async getDocTemplates() {
    const { task, companyId, userId } = this;
    let url = "";

    if (this.isServices) {
      url = API_ROUTES.CASE_EXPERT_DOCUMENT_TEMPLATE(this.serviceId, this.serviceTemplateId);
    } else {
      if (this.level === COMPANY_LEVEL) {
        url = API_ROUTES.EXPERT_FROM_COMPANY_LEVEL_TO_EMPLOYER_GET_DOCUMENT_TEMPLATES_LIST(
          companyId
        );
      } else {
        if (task.role === "employer") {
          url = API_ROUTES.EXPERT_FROM_EMPLOYEE_LEVEL_TO_EMPLOYER_GET_DOCUMENT_TEMPLATES_LIST(
            companyId,
            userId
          );
        }

        if (task.role === "employee") {
          url = API_ROUTES.EXPERT_FROM_EMPLOYEE_LEVEL_TO_EMPLOYEE_GET_DOCUMENT_TEMPLATES_LIST(
            companyId,
            userId
          );
        }
      }
    }

    const { data } = await this.axios.get<API_TTaskSelect[]>(url);

    if (!data) return;

    this.docTemplates = data.map((v) => ({ value: v.ID, label: v.name }));
  }

  // async getCaseProgressSteps(serviceId: number, templateId: number) {
  //   const { data } = await this.axios.get<API_TTaskSelect[]>(
  //     API_ROUTES.CASE_EXPERT_CASE_PROGRESS_STEP(serviceId, templateId)
  //   );

  //   if (!data) return;

  //   this.progressSteps = data.map((v) => ({ value: v.ID, label: v.name }));

  //   if (!this.isCaseCompleted) return;

  //   this.task.case_progress_step_id = this.progressSteps[this.progressSteps.length - 1]
  //     .value as number;

  //   this.progressSteps = [this.progressSteps[this.progressSteps.length - 1]];
  // }

  closeTaskPopup() {
    this.showPopup = false;

    this.task.case_progress_step_id = null;

    this.task.document_template_v2_id = 0;

    this.$emit("close");
  }

  prepareRequestPayload(data) {
    const requestPayload = { ...data };

    if (Object.prototype.hasOwnProperty.call(requestPayload, "title") && !requestPayload.title) {
      Object.assign(requestPayload, {
        title: requestPayload.name,
      });
    }

    if (this.isCompliance) {
      if (Object.prototype.hasOwnProperty.call(requestPayload, "case_progress_step_id")) {
        delete requestPayload["case_progress_step_id"];
      }
    }

    return requestPayload;
  }

  loading = false;

  async createTask() {
    try {
      this.loading = true;

      const { companyId, userId } = this;

      let url = "";

      if (this.isServices) {
        url = API_ROUTES.CASE_TASKS(this.serviceId);
      } else {
        const { forUserRole, level } = this;

        if (level === COMPANY_LEVEL) {
          if (forUserRole === EMPLOYER_ROLE) {
            url = API_ROUTES.EXPERT_FROM_COMPANY_LEVEL_TO_EMPLOYER_TASKS(companyId);
          }
        } else {
          url = API_ROUTES.EXPERT_FOR_EMPLOYEE_TASKS(companyId, userId);
        }
      }

      if (!url) return;

      await this.axios.post(url, this.prepareRequestPayload(this.task));

      SMCases.setTasksTableNeedsUpdate(true);

      this.clean();

      this.$emit("update");

      this.closeTaskPopup();
    } finally {
      this.loading = false;
    }
  }

  clean() {
    // TODO: Find better approach. Very strange behavior in "portal";
    this.showEditor = false;

    Object.keys(this.task).forEach((key) => {
      (this.task as API_TTask)[key] = "";
    });

    this.$nextTick(() => {
      Object.assign(this.task.description, "");

      this.showEditor = true;
    });
  }
}
